import { serverTrackAndIdentify } from 'utils/segment';
import { browserWindow } from 'utils/window';

export const trackPPQData = (data, result) => {
  const boolResult = (data) => {
    return data === 'yes';
  };

  return serverTrackAndIdentify({
    event: 'Engagement Form Completed',
    eventProperties: {
      form_name: 'ppq',
      version: '1.1',
      version_start_date: '07-24-2020',
      page_url: browserWindow.location.pathname,
      step: 1,
      result: result,
      partner_name: data.partner_name,

      //PPQ Form Values
      state: data.state,
      ideal_investment_amount: data.ideal_investment_amount,
      estimated_credit_score: data.credit_score,
      property_type: data.property_type,
      property_use: data.property_usage,
      estimated_mortgage_balance: data.mortgage_balance,
      estimated_home_value: data.home_value,
      late_payments: data.num_late_payments,
      foreclosure: boolResult(data.foreclosure),
      bankruptcy: boolResult(data.bankruptcy),
    },
  });
};

export const trackSharedEmail = (email, partnerName) => {
  return serverTrackAndIdentify({
    event: 'Engagement Form Completed',
    eventProperties: {
      form_name: 'ppq',
      version: '1.0',
      version_start_date: '07-24-2020',
      page_url: browserWindow.location.pathname,
      step: 2,
      email: email,
      partner_name: partnerName,
    },
  });
};
